module.exports = __webpack_public_path__ + "media/common/images/innogy_style/digitalization-1cab8fe2839bb5e9045bb5c063221a8b.svg";